<script lang="ts">
    
    import { accountsService } from "../../Services";

    export let accountId: string;

    let name = '';

    $: updateName(accountId);

    async function updateName(accountId: string): Promise<void> {
        if (!accountId) {
            name = '';
            return;
        }
        try {
            const account = await accountsService.getAccount(accountId);
            name = account.name.value;
        } catch (error) {
            console.error(error);
        }
    }

</script>

{name}
